import { Injectable } from '@angular/core';
import { SelfScanService } from '../../models/loyalty-selfScan-service.model';
import { Observable } from 'rxjs/Observable';
import { ListMetadata } from '../../models/list-metadata.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {MessageService} from 'primeng/api';
import {SelfScanConf} from '../../models/loyalty-selfScan.model';
import {publishReplay, refCount} from 'rxjs/operators';

@Injectable()
export class LoyaltySelfscanserviceService {

  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(selfscanserviceId): Observable <SelfScanService> {
    return this.http.get(this.baseUrl + '/self_scanning/services/' + selfscanserviceId);
  }

  list (
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<SelfScanService> , metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/self_scanning/services/getServices?'  + params.toString());

  }

  update(selfscan: SelfScanService): Observable<SelfScanConf> {
    return this.http.put(this.baseUrl + '/self_scanning/services/' + selfscan.id, selfscan);
  }

  getFields () {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/SelfScanningServiceDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }


}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-selfscanservice.service.ts